import Component from 'D:/HBuilderProjects/园博园/uni_modules/uni-list/components/uni-list/uni-list.vue'
wx.createComponent(Component)